export class UserBalance {
    balance?: number = 0;
    totalActiveCapital?: number = 0;
    totalNetCapital?: number = 0;
    totalPendingCapital?:number = 0;
    totalCapitalGain?: number = 0;
    today_withdrawal?: any = 0;
    pending_cap_withdrawal?:any = 0;
    available_balance?:any = 0;
    frozen_bonus?:any = 0;
    frozen_balance?:any = 0;
    walletBalance?:any = 0;
    profitiability_bonus?:any=0;
    profitiability_extra_bonus?:any=0;
    todayBonus?:any = 0;
}